import React, { memo } from "react";

export default memo(({ score }) => {
  return <div>Score: {score}</div>;
});
